import SessionClient from "util/SessionClient";
import { useDispatch } from "react-redux";
import actions from "rdx/actions";

const useRestrictAccessModal = () => {
  const session = new SessionClient();
  const { backOfficeAccess, backOfficeAccessTrue } = session;
  // Only a missing or banned user lacks back office access; PlatformLayout redirects them away.
  const isUnpaidUser = !backOfficeAccess;
  const integrityTrainingRequired = backOfficeAccess === "integrity_restricted";
  const isRestrictedUser = isUnpaidUser || integrityTrainingRequired;

  const dispatch = useDispatch();

  const restrictAccessModal = () => {
    if (integrityTrainingRequired) {
      dispatch(actions.setIntegrityTrainingModalVisible(true));
    }
  };

  return {
    isUnpaidUser,
    backOfficeAccessTrue,
    integrityTrainingRequired,
    isRestrictedUser,
    restrictAccessModal,
  };
};

export default useRestrictAccessModal;
